<form [formGroup]="mortProviderFrmGrp">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <label class="font-size-36">
                    {{ 'morgage_provider.heading' |translate }}
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div>{{'morgage_provider.title' |translate}}</div>
                <select class="wdd-fl" formControlName="provider" aria-describedby="suffixOptional"
                    aria-required="true">
                    <option *ngFor="let providerObj of mortgageProvider" [value]="providerObj">{{providerObj}}
                    </option>
                </select>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col" *ngIf="mortProviderFrmGrp.get('isNotInList').value">
                <div>{{'morgage_provider.yourProvider' |translate }}</div>
                <input type="text" formControlName="enteredProvider" aria-required="true" autocomplete="off">
                <ng-container *ngIf="mortProviderFrmGrp.get('enteredProvider')?.errors && 
                mortProviderFrmGrp.get('enteredProvider')?.errors.mortProviderInvalid">
                    <small class="form-text"> <img src="./assets/images/menu_icons/Alert.svg" alt="">
                        <span class="pt-1"> {{ 'morgage_provider.providerErrMsg' | translate }} </span>
                    </small>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row d-flex btnSave  buttonsView mr-md-3">
        <button type="button" class="mobile-view-btn buttonCommon saveNextBtn  mt-md-5" (click)="onContinue()">{{
            'buttonallpages.buttonlable' | translate }}</button>

        <cancel-button class="cnc-fll cancelMargin"></cancel-button>
        <button type="button" class=" desktop-view-btn buttonCommon saveNextBtn ml-md-3 " (click)="onContinue()">{{
            'buttonallpages.buttonlable' | translate }}</button>
    </div>

</form>